module.exports = __webpack_public_path__ + "TriangulaLogo.png";